import { useEffect, useState } from 'react';
import { useCartContext } from 'components/globalContext/CartContext';
import { CartItem, getCart, CART_KEY } from 'lib/util/cart';

export const useCart = (): {
  cart: CartItem[];
  addToCart: (item: CartItem) => void;
  removeFromCart: (itemId: string) => void;
  clearCart: () => void;
  getQuantity: (itemId: string) => number;
  validateQuantity: (item: CartItem, fromCart: boolean) => boolean;
  updateQuantity: (itemid: string, quantity: number) => boolean;
  fetchCart: () => CartItem[];
  getQuantityLeftById: (itemId: string, quantity: number) => number;
  getMaxQuantity: (itemMaxUs: number, itemMaxIntl: number, itemId: string) => number;
} => {
  const { setCartContext, cartContext } = useCartContext();
  const [cart, setCart] = useState<CartItem[]>([]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const getLocalStorageValue: CartItem[] = getCart();
      setCart(getLocalStorageValue);
    }
  }, [setCartContext, cartContext]);

  const syncCart = (updatedCart: CartItem[]): void => {
    setCart(updatedCart);
    localStorage.setItem(CART_KEY, JSON.stringify(updatedCart));
    let returnquantity = 0;
    updatedCart.forEach((element) => {
      returnquantity += element.quantity;
    });
    setCartContext(returnquantity);
  };
  const fetchCart = (): CartItem[] => {
    return getCart();
  };

  const addCartItem = (item: CartItem): void => {
    const currentCartItems = fetchCart();

    if (currentCartItems.some((items) => items.id === item.id)) {
      const updatedItems = currentCartItems.map((targetitem) => {
        if (targetitem.id === item.id) {
          // If the ID matches, update the quantity
          return { ...targetitem, quantity: Number(targetitem.quantity) + Number(item.quantity) };
        }
        return targetitem; // Keep other items unchanged
      });
      syncCart(updatedItems);
    } else {
      const updatedCart = [...currentCartItems, item];
      syncCart(updatedCart);
    }
  };
  const getQuantityById = (itemId: string): number => {
    let returnquantity = 0;
    const currentCartItems = fetchCart();
    if (currentCartItems.some((items) => items.id === itemId)) {
      returnquantity = currentCartItems.find((item) => item.id === itemId)?.quantity as number;
    }
    return returnquantity;
  };
  const getQuantityLeftById = (itemId: string, quantity: number): number => {
    let returnquantity = quantity;
    if (cart.some((items) => items.id === itemId)) {
      const cartItemToCheck = cart.find((item) => item.id === itemId) as CartItem;
      returnquantity = (cartItemToCheck?.itemMaxUs as number) - cartItemToCheck.quantity;
    }
    return returnquantity;
  };

  const removeCartItem = (itemId: string): void => {
    const updatedCart = fetchCart().filter((item) => item.id !== itemId);
    syncCart(updatedCart);
  };

  const clearCartItem = (): void => {
    syncCart([]);
  };
  const validateQuantity = (cartItem: CartItem, fromCart: boolean): boolean => {
    let returnVal = false;
    const x = getQuantityById(cartItem.id as string);
    const itemMax = cartItem.itemMaxUs;
    if (x + cartItem.quantity <= (itemMax as number)) {
      returnVal = true;
    }
    if (fromCart) {
      if (cartItem.quantity <= (itemMax as number)) {
        returnVal = true;
      }
    }
    return returnVal;
  };
  const getMaxQuantity = (itemMaxUs: number, itemMaxIntl: number, itemId: string): number => {
    let itemsAlreadyIn = 0;
    if (cart.some((items) => items.id === itemId)) {
      const cartItemToCheck = cart.find((item) => item.id === itemId) as CartItem;
      itemsAlreadyIn = cartItemToCheck.quantity;
    }
    return itemMaxUs - itemsAlreadyIn;
  };
  const updateQuantity = (itemid: string, quantity: number): boolean => {
    let returnVal = false;
    const currentCartItems = fetchCart();
    if (currentCartItems.some((items) => items.id === itemid)) {
      const updatedItems = currentCartItems.map((targetitem) => {
        if (targetitem.id === itemid) {
          returnVal = true;
          // If the ID matches, update the quantity
          return { ...targetitem, quantity: quantity };
        }
        return targetitem; // Keep other items unchanged
      });

      syncCart(updatedItems);
    }
    return returnVal;
  };

  return {
    cart,
    addToCart: addCartItem,
    removeFromCart: removeCartItem,
    clearCart: clearCartItem,
    getQuantity: getQuantityById,
    validateQuantity: validateQuantity,
    updateQuantity: updateQuantity,
    fetchCart: fetchCart,
    getQuantityLeftById: getQuantityLeftById,
    getMaxQuantity: getMaxQuantity,
  };
};
